import { render, staticRenderFns } from "./huilianyi.vue?vue&type=template&id=16201764&scoped=true&"
import script from "./huilianyi.vue?vue&type=script&lang=ts&"
export * from "./huilianyi.vue?vue&type=script&lang=ts&"
import style0 from "./huilianyi.vue?vue&type=style&index=0&id=16201764&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16201764",
  null
  
)

export default component.exports